import { googleMapsKey } from '../config';

export const getPropertyGoogleMapsImagePath = (geoCode) =>
  `https://maps.googleapis.com/maps/api/streetview?size=4000x4000&location=${geoCode}&key=${googleMapsKey}`;
